"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Cryptobox_1 = require("../Cryptobox");
var PersistedRecord = (function () {
    function PersistedRecord(serialised, id) {
        this.created = Date.now();
        this.id = id;
        this.serialised = serialised;
        this.version = Cryptobox_1.default.prototype.VERSION;
    }
    return PersistedRecord;
}());
exports.default = PersistedRecord;



//////////////////
// WEBPACK FOOTER
// ./dist/commonjs/store/PersistedRecord.js
// module id = 215
// module chunks = 0 1